import {
    EntityTypeName,
    PrDeductionEntity,
    PrDistrainmentDepositClosingEntity,
    PrInsolvencyDepositClosingEntity
} from "@odata/GeneratedEntityTypes";
import {
    PrDeductionTypeCode,
    PrDistrainmentDepositClosingCode,
    PrInsolvencyDepositClosingCode
} from "@odata/GeneratedEnums";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { paymentDetailFields, SAVED_ACCOUNTS_PATH } from "@pages/banks/bankAccounts/BankAccounts.utils";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import { addBankAccountDefinitions, isAmongTypes, isTransferDeposit } from "@pages/payroll/deduction/Deduction.utils";
import DepositClosingFormView from "@pages/payroll/deduction/DepositClosingFormView";
import i18next from "i18next";

import { BasicInputSizes, FieldType } from "../../../enums";
import { IFormDef } from "../../../views/formView/Form";

export const getDefinitions: IGetDefinition = (): IDefinition => {

    const form: IFormDef = {
        id: `DepositClosingSpecialForm`,
        summary: [],
        translationFiles: getDefinitions.translationFiles,
        formControl: DepositClosingFormView,
        fieldDefinition: {
            [PrDeductionEntity.InsolvencyDepositClosing]: {
                type: FieldType.ComboBox,
                width: BasicInputSizes.XL,
                isRequired: true,
                // keep this as default to aretate width of dialog (not to be jumpy)
                defaultValue: PrInsolvencyDepositClosingCode.TransferToInsolvencyAdministrator,
                label: i18next.t("Deduction:Form.DepositClosing"),
                fieldSettings: {
                    displayName: PrInsolvencyDepositClosingEntity.Name
                },
                isVisible: isAmongTypes([PrDeductionTypeCode.InsolvencyDeposit]),
                affectedFields: [
                    { id: PrDeductionEntity.DateLegallyEffective }
                ],
                affectedGroups: ["bankAccount"]
            },
            [PrDeductionEntity.DistrainmentDepositClosing]: {
                type: FieldType.ComboBox,
                width: BasicInputSizes.XL,
                isRequired: true,
                // keep this as default to aretate width of dialog (not to be jumpy)
                defaultValue: PrDistrainmentDepositClosingCode.TransferToDistrainer,
                label: i18next.t("Deduction:Form.DepositClosing"),
                fieldSettings: {
                    displayName: PrDistrainmentDepositClosingEntity.Name
                },
                isVisible: isAmongTypes([PrDeductionTypeCode.DistrainmentDeposit]),
                affectedFields: [
                    { id: PrDeductionEntity.DateLegallyEffective }
                ],
                affectedGroups: ["bankAccount"]
            },
            [PrDeductionEntity.DateLegallyEffective]: {
                width: BasicInputSizes.L,
                isRequired: true,
                isVisible: isTransferDeposit,
            },
        },
        groups: [{
            id: "main",
            rows: [[
                { id: PrDeductionEntity.InsolvencyDepositClosing },
                { id: PrDeductionEntity.DistrainmentDepositClosing },
                { id: PrDeductionEntity.DateLegallyEffective }
            ]]
        }, {
            id: "bankAccount",
            rows: [[
                { id: SAVED_ACCOUNTS_PATH }
            ], [
                ...paymentDetailFields
            ]]
        }]
    };

    addBankAccountDefinitions(form);

    return {
        form
    };
};

getDefinitions.translationFiles = [
    "Deduction", "Common",
    getEnumNameSpaceName(EntityTypeName.PrDistrainmentDepositClosing),
    getEnumNameSpaceName(EntityTypeName.PrInsolvencyDepositClosing),
];